import {
  CONFIG_FETCH,
  CONFIG_IS_FETCING,
} from 'constants/config'
import {
  danger,
} from 'actions/notification'

export const configFetch=()=>(dispatch)=>{
  dispatch(configIsFetching(true))
  return fetch('/config.json')
    .then((res)=>res.json())
    .then((res)=>dispatch(configFetched(res)))
    .then(()=>dispatch(configIsFetching(false)))
    .catch((e)=>{ dispatch(danger('Fail Load config.json('+e+')')) })
}
export const configFetched= (payload)=>   ({ type:CONFIG_FETCH,       payload:payload })
export const configIsFetching=(payload)=> ({ type:CONFIG_IS_FETCING,  payload:payload })



// WEBPACK FOOTER //
// ./src/actions/config.js